import { useQuery } from "@tanstack/react-query"
import { queryClient as qc } from 'keys'
import { getAssessmentDefFetch, getAssessmentDefsFetch } from "store/middlewares/assessment.crud"
import { useParams, useSearchParams } from "react-router-dom"
import { actions } from "store"
import { useDispatch } from "react-redux"

const useGetAssessmentDef = () => {
    const [searchParams] = useSearchParams();
    const dispatch = useDispatch()
    const params = useParams()

    const assessmentDefID = searchParams.get('assessmentDef');

    const assessmentDef = assessmentDefID || params.assessmentDefID

    return useQuery(
        {
            queryKey: [qc.assessmentDef, assessmentDef],
            queryFn: async ({ signal }) => {
                const { data } = await getAssessmentDefFetch({ id: assessmentDef, signal, })
                dispatch(actions.setAssessmentDef(data))
            },
            enabled: !!assessmentDef
        })
}

export default { useGetAssessmentDef }